import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { linkUrl } from "../NovelGen/linkUrl"; // Adjust the path to your linkUrl as needed

import "./Podcast.css";

const CardProfile = ({ songName }) => {
  const [currentTime, setCurrentTime] = useState("0:00");
  const [duration, setDuration] = useState("0:00");
  const [pause, setPause] = useState(false);
  const playerRef = useRef(null);
  const timelineRef = useRef(null);
  const playheadRef = useRef(null);

  const song = {
    name: songName,
    author: "Royalty",
    img: "https://www.bensound.com/bensound-img/buddy.jpg",
    audio:
      "https://www.buzzsprout.com/2011416/10872973-toni-morrison-s-beloved-episode-by-courtney-thorsson.mp3",
  };

  useEffect(() => {
    const player = playerRef.current;
    player.addEventListener("loadedmetadata", () => {
      setDuration(formatTime(player.duration));
    });
    player.addEventListener("timeupdate", timeUpdate);

    return () => {
      player.removeEventListener("loadedmetadata", () => {
        setDuration(formatTime(player.duration));
      });
      player.removeEventListener("timeupdate", timeUpdate);
    };
  }, []);

  const timeUpdate = () => {
    const player = playerRef.current;
    const playPercent = (player.currentTime / player.duration) * 100;
    playheadRef.current.style.left = `${playPercent}%`;
    setCurrentTime(formatTime(player.currentTime));
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60)
      .toString()
      .padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  const playOrPause = () => {
    const player = playerRef.current;
    if (pause) {
      player.pause();
    } else {
      player.play();
    }
    setPause(!pause);
  };

  const changeCurrentTime = (e) => {
    const player = playerRef.current;
    const timeline = timelineRef.current;
    const newTime =
      (e.nativeEvent.offsetX / timeline.offsetWidth) * player.duration;
    player.currentTime = newTime;
  };

  return (
    <div className="card">
      <div className="current-song">
        <audio ref={playerRef}>
          <source src={song.audio} type="audio/ogg" />
        </audio>
        <span className="song-name">{song.name}</span>
        <div ref={timelineRef} id="timeline" onClick={changeCurrentTime}>
          <div ref={playheadRef} id="playhead"></div>
        </div>
        <div className="time">
          <div className="current-time">{currentTime}</div>
          <div className="end-time">{duration}</div>
        </div>
        <div className="controls">
          <button onClick={playOrPause} className="play current-btn">
            {!pause ? (
              <i className="fas fa-play"></i>
            ) : (
              <i className="fas fa-pause"></i>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

const TagButton = ({ children }) => (
  <button
    style={{
      display: "flex",
      padding: "6px 12px",
      alignItems: "center",
      gap: "4px",
      borderRadius: "8px",
      border: "0.25px solid var(--Gray-Black, #000)",
      backgroundColor: "transparent",
      boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.08)",
    }}
  >
    {children}
  </button>
);

const Podcast = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/podcasts/fc0f671d-48ae-457a-a7cb-a755adf06514");
    window.scrollTo(0, 0);
  };

  const handleBluestEyeClick = async (e) => {
    e.preventDefault(); // Prevent the default anchor behavior
    e.stopPropagation(); // Prevent the event from bubbling up to the Podcast-content div

    navigate("/books/OcalhZUBXRMAzKyK5xyE");
    window.scrollTo(0, 0);
  };

  const songName = "Toni Morrison's Beloved";

  return (
    <div className="Podcast-Container" id="Podcast">
      <div className="Podcast-header">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
        >
          <path
            d="M4.19656 4.19487C3.30269 5.08864 2.59363 6.14974 2.10987 7.31756C1.62611 8.48539 1.37712 9.73706 1.37712 11.0011C1.37712 12.2652 1.62611 13.5168 2.10987 14.6847C2.59363 15.8525 3.30269 16.9136 4.19656 17.8074C4.3218 17.937 4.39109 18.1107 4.38953 18.291C4.38796 18.4712 4.31566 18.6436 4.18819 18.7711C4.06072 18.8986 3.88829 18.9709 3.70802 18.9725C3.52776 18.974 3.3541 18.9047 3.22444 18.7795C2.20293 17.758 1.39263 16.5454 0.83979 15.2108C0.286953 13.8761 0.00241089 12.4457 0.00241089 11.0011C0.00241089 9.55653 0.286953 8.12609 0.83979 6.79147C1.39263 5.45685 2.20293 4.24419 3.22444 3.22274C3.3541 3.09751 3.52776 3.02821 3.70802 3.02978C3.88829 3.03135 4.06072 3.10365 4.18819 3.23112C4.31566 3.35859 4.38796 3.53102 4.38953 3.71128C4.39109 3.89154 4.3218 4.0652 4.19656 4.19487ZM7.11431 7.11262C6.08322 8.14402 5.50399 9.54271 5.50399 11.0011C5.50399 12.4595 6.08322 13.8582 7.11431 14.8896C7.17823 14.9535 7.22894 15.0294 7.26353 15.1129C7.29812 15.1965 7.31593 15.286 7.31593 15.3764C7.31593 15.4668 7.29812 15.5563 7.26353 15.6398C7.22894 15.7233 7.17823 15.7992 7.11431 15.8631C7.05039 15.927 6.97451 15.9777 6.89099 16.0123C6.80747 16.0469 6.71796 16.0647 6.62756 16.0647C6.53716 16.0647 6.44765 16.0469 6.36413 16.0123C6.28062 15.9777 6.20473 15.927 6.14081 15.8631C5.50222 15.2247 4.99565 14.4667 4.65003 13.6325C4.30442 12.7983 4.12653 11.9041 4.12653 11.0011C4.12653 10.0981 4.30442 9.20398 4.65003 8.36975C4.99565 7.53552 5.50222 6.77754 6.14081 6.13912C6.26991 6.01002 6.44499 5.9375 6.62756 5.9375C6.81013 5.9375 6.98522 6.01002 7.11431 6.13912C7.24341 6.26821 7.31593 6.4433 7.31593 6.62587C7.31593 6.80843 7.24341 6.98352 7.11431 7.11262V7.11262ZM14.8913 6.13912C14.9552 6.07509 15.031 6.0243 15.1146 5.98964C15.1981 5.95498 15.2876 5.93714 15.3781 5.93714C15.4685 5.93714 15.558 5.95498 15.6416 5.98964C15.7251 6.0243 15.8009 6.07509 15.8648 6.13912C16.5034 6.77754 17.01 7.53552 17.3556 8.36975C17.7012 9.20398 17.8791 10.0981 17.8791 11.0011C17.8791 11.9041 17.7012 12.7983 17.3556 13.6325C17.01 14.4667 16.5034 15.2247 15.8648 15.8631C15.8009 15.927 15.725 15.9777 15.6415 16.0123C15.558 16.0469 15.4685 16.0647 15.3781 16.0647C15.2877 16.0647 15.1982 16.0469 15.1146 16.0123C15.0311 15.9777 14.9552 15.927 14.8913 15.8631C14.8274 15.7992 14.7767 15.7233 14.7421 15.6398C14.7075 15.5563 14.6897 15.4668 14.6897 15.3764C14.6897 15.286 14.7075 15.1965 14.7421 15.1129C14.7767 15.0294 14.8274 14.9535 14.8913 14.8896C15.9224 13.8582 16.5016 12.4595 16.5016 11.0011C16.5016 9.54271 15.9224 8.14402 14.8913 7.11262C14.8273 7.04875 14.7765 6.97289 14.7418 6.88936C14.7072 6.80584 14.6893 6.7163 14.6893 6.62587C14.6893 6.53544 14.7072 6.4459 14.7418 6.36237C14.7765 6.27885 14.8273 6.20298 14.8913 6.13912ZM17.8091 3.22412C17.938 3.09523 18.1128 3.02283 18.2951 3.02283C18.4774 3.02283 18.6523 3.09523 18.7812 3.22412C20.8438 5.28698 22.0025 8.08466 22.0025 11.0018C22.0025 13.9189 20.8438 16.7166 18.7812 18.7795C18.6515 18.9047 18.4779 18.974 18.2976 18.9725C18.1173 18.9709 17.9449 18.8986 17.8174 18.7711C17.69 18.6436 17.6177 18.4712 17.6161 18.291C17.6145 18.1107 17.6838 17.937 17.8091 17.8074C18.7029 16.9136 19.412 15.8525 19.8958 14.6847C20.3795 13.5168 20.6285 12.2652 20.6285 11.0011C20.6285 9.73706 20.3795 8.48539 19.8958 7.31756C19.412 6.14974 18.7029 5.08864 17.8091 4.19487C17.6802 4.06594 17.6078 3.89111 17.6078 3.70881C17.6078 3.5265 17.6802 3.35167 17.8091 3.22274V3.22412ZM13.7528 11.0011C13.7528 11.7305 13.4631 12.4299 12.9474 12.9457C12.4316 13.4614 11.7322 13.7511 11.0028 13.7511C10.2735 13.7511 9.57399 13.4614 9.05827 12.9457C8.54254 12.4299 8.25281 11.7305 8.25281 11.0011C8.25281 10.2718 8.54254 9.5723 9.05827 9.05657C9.57399 8.54085 10.2735 8.25112 11.0028 8.25112C11.7322 8.25112 12.4316 8.54085 12.9474 9.05657C13.4631 9.5723 13.7528 10.2718 13.7528 11.0011V11.0011Z"
            fill="white"
          />
        </svg>
        <p>Featured Podcast</p>
      </div>
      <div className="Podcast-content" onClick={handleButtonClick}>
        <div onClick={(e) => e.stopPropagation()}>
          <CardProfile songName={songName} />
        </div>
        <img src="Chloe.png" alt="Chloe" />
        <p>
          <a href="#" className="highlight">
            Chloe Anthony Wofford Morrison
          </a>
          , known as
          <a href="#" className="highlight">
            {" "}
            Toni Morrison
          </a>
          , was an American novelist. Her first novel,
          <a href="#" onClick={handleBluestEyeClick} className="highlight">
            The Bluest Eye
          </a>
          , was published in 1970. The critically acclaimed Song of Solomon
          brought her national attention and won the National Book Critics
          Circle Award.
        </p>
        {/* Remove these tags, which don't work, but might be needed. Not sure what KU intended for them.}
        <div className="tagbuttons">
          <TagButton>American Civil War</TagButton>
          <TagButton>Cincinnati</TagButton>
          <TagButton>Fugitive Slave Act of 1850</TagButton>
          <TagButton>Pulitzer Prize for Fiction</TagButton>
          <TagButton>Pulitzer Prize for Fiction</TagButton>
          <TagButton>Family relationships</TagButton>
        </div>
        */}
      </div>
    </div>
  );
};

export default Podcast;
